<template>
  <div :class="classModifiers">
    <h2 class="research-widget__title"><slot></slot></h2>
    <div class="research-widget__content">
      <template v-if="shutdown">
        <p class="research-widget__para">
          PredictIt started as a project of Victoria University of Wellington, to facilitate
          research into the way markets forecast events. Now through our application as a federally
          regulated Event Market platform we are expanding into markets beyond politics.
        </p>
        <p class="research-widget__para">
          We are excited for this transition and hope you follow us on Twitter to learn more about
          future market launches.
        </p>
        <button type="button" class="button button--medium button--submit" @click="onClick">
          Learn More
        </button>
      </template>
      <template v-else>
        <p class="research-widget__para">
          A project of the Prediction Market Research Consortium, PredictIt has been established to
          facilitate research into the way markets forecast events.
        </p>
        <p class="research-widget__para">
          In order to enable researchers to take advantage of the opportunities presented by
          prediction markets, we make our data available to the academic community at no cost.
        </p>
        <div class="research-widget__button">
          <button type="button" class="button button--medium button--submit" @click="onClick">
            Learn More
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script src="./research-widget.js"></script>
<style src="./research-widget.scss" lang="scss"></style>
